/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import styled from "styled-components";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import Button from "../Buttons/Button";
import Input from "../Input";
import { TextSubtitle, TextTitle } from "../../styles";
import verifyIllustration from "../../assets/illustrations/verifyotp.svg";
import InlineLink from "../InlineLink";
import Card from "../Cards/Card";

interface VerifyOtpPageProps {
    handleView: React.Dispatch<React.SetStateAction<string>>;
    verifyOtp: (data: { otp: number }) => Promise<void>;
}

const validationSchema = yup.object({
    otp: yup.number().required(),
});

const VerifyOtpPage: React.FC<VerifyOtpPageProps> = ({
    handleView,
    verifyOtp,
    ...props
}) => (
    <Card alt="login page" imageSrc={verifyIllustration}>
        <Formik
            initialValues={{ otp: null }}
            validationSchema={validationSchema}
            onSubmit={(data, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                verifyOtp(data);
                setSubmitting(false);
                resetForm();
            }}
        >
            {({ values, isSubmitting }) => (
                <Form>
                    <LeftContainer>
                        <TextContainer>
                            <Title>Verify Email</Title>
                            <Subtitle>
                                Please confirm that you want to use this as your
                                email address
                            </Subtitle>
                        </TextContainer>
                        <InputContainer>
                            <Field
                                name="otp"
                                label="Enter OTP"
                                type="number"
                                as={Input}
                            />
                        </InputContainer>
                        <ButtonContainer>
                            <Button
                                text="Verify"
                                disabled={isSubmitting}
                                type="submit"
                            />
                        </ButtonContainer>
                    </LeftContainer>
                </Form>
            )}
        </Formik>
    </Card>
);

const LeftContainer = styled.div`
    align-content: center;
    display: grid;
    gap: 1.5em;
    grid-template-rows: repeat(3, min-content);
    height: 100%;
    width: 500px;
    @media (max-width: 1000px) {
        width: 450px;
    }

    @media (max-width: 768px) {
        width: 400px;
    }

    @media (max-width: 650px) {
        width: 300px;
    }

    @media (max-width: 450px) {
        width: 98%;
    }
`;

const TextContainer = styled.div`
    display: grid;
    gap: 0.2em;
`;

const Title = styled(TextTitle)``;

const Subtitle = styled(TextSubtitle)``;

const InputContainer = styled.div`
    display: grid;
    gap: 1em;
`;

const ButtonContainer = styled.div``;

const ExtraContainer = styled.div`
    display: grid;
    gap: 0.5em;
    grid-template-rows: repeat(2, min-content);
`;

export default VerifyOtpPage;
